// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tab-content[data-v-a00d5c4c]{max-width:100%!important;overflow:visible!important}", "",{"version":3,"sources":["webpack://./chat/vue/widget/tabs/ContentTab.vue"],"names":[],"mappings":"AACA,8BAEI,wBAAA,CADA,0BACA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
